const globalStyles = {
    'html, body': {
        fontFamily: "'GTEesti', sans-serif",
        fontWeight: 300,
        textRendering: 'geometricPrecision',
        scrollBehavior: 'smooth',
    },
    '.no-focus-outline *:focus, [data-js-focus-visible] :focus:not([data-focus-visible-added]):not( [data-focus-visible-disabled] )': {
        outlineOffset: '0 !important',
        outlineColor: 'transparent !important',
        outlineStyle: 'none !important',
        outlineWidth: '0 !important',
        boxShadow: 'none !important',
    },
    '.no-focus-outline *:focus-within': {
        outlineOffset: '0 !important',
        outlineColor: 'transparent !important',
        outlineStyle: 'none !important',
        outlineWidth: '0 !important',
        boxShadow: 'none !important',
        // borderColor: 'inherit !important',
    },
    '*:focus': {
        outlineOffset: '3px !important',
        outlineColor: '#1e90ff !important',
        outlineStyle: 'auto !important',
        outlineWidth: '4px !important',
        boxShadow: 'none !important',
    },
    'body a:hover, body .chakra-link:hover': {
        textDecoration: 'none',
    },
    'body .chakra-modal__content-container': {
        zIndex: 'tooltip',
    },
    'body #chakra-toast-manager-top-right': {
        top: {
            base: '100px !important',
            md: '189px !important',
        },
        left: {
            base: '16px !important',
            md: 'auto !important',
        },
        right: {
            base: '16px !important',
            md: '50px !important',
        },
    },
    '.grecaptcha-badge': {
        display: 'none',
    },
    // Salesforce Embedded Chat Styles
    '.embeddedServiceHelpButton .helpButton': {
        width: 'auto !important',
        bottom: '16px',
        right: '16px',
        height: '65px',
    },
    '.embeddedServiceHelpButton .helpButtonDisabled': {
        display: 'none !important',
        visibility: 'hidden',
    },
    '.embeddedServiceHelpButton .helpButton .uiButton': {
        backgroundColor: 'transparent',
        fontFamily: "'GTEesti', sans-serif",
        fontWeight: 300,
        borderRadius: 0,
        minWidth: '1px',
        maxWidth: 'none',
        padding: '0px',
        letterSpacing: '3px',
        textTransform: 'uppercase',
        fontSize: '12px',
        boxShadow: 'none',
        transition: 'all .15s ease-in',
        height: '65px',
        backgroundRepeat: 'no-repeat',
    },
    '.embeddedServiceHelpButton .helpButton .uiButton:hover': {
        color: '#262626',
    },
    '.embeddedServiceHelpButton .helpButton .uiButton:hover::before, .embeddedServiceHelpButton .helpButton .uiButton:focus::before': {
        display: 'none',
    },
    'button[embeddedservice-chatheader_chatheader] svg': {
        maxWidth: '19px',
    },
    '.embeddedServiceHelpButton .uiButton .helpButtonLabel': {
        display: 'none',
    },

    // Animations to be injected separately
    '@global': `
  
      @keyframes changePosition {
        0% { transform: translate(15px, 0); }
        40.1% { transform: translate(0, 0); }
        60.1% { transform: translate(0, 0); }
        100% { transform: translate(-15px, 0); }
      }
  
      @-webkit-keyframes webChangePosition {
        0% { -webkit-transform: translate(15px, 0); }
        40.1% { -webkit-transform: translate(0, 0); }
        60.1% { -webkit-transform: translate(0, 0); }
        100% { -webkit-transform: translate(-15px, 0); }
      }
  
      @keyframes changeOpacity {
        0% { opacity: 0; }
        40.1% { opacity: 1; }
        60.1% { opacity: 1; }
        100% { opacity: 0; }
      }
  
      @-webkit-keyframes webChangeOpacity {
        0% { opacity: 0; }
        40.1% { opacity: 1; }
        60.1% { opacity: 1; }
        100% { opacity: 0; }
      }
  
      .embeddedServiceHelpButton .embeddedServiceIcon {
        margin-right: 0px;
        width: 65px;
        display: inline-block !important;
        animation: changeIcon 4000ms infinite, changeOpacity 2000ms infinite, changePosition 2000ms linear infinite;
        -webkit-animation: changeIcon 4000ms infinite, webChangeOpacity 2000ms infinite, webChangePosition 2000ms linear infinite;
      }
    `,
    '.embedded-messaging > .embeddedMessagingFrame[class~="isMaximized"]': {
        zIndex: 9999,
    },
    'button#embeddedMessagingConversationButton': {
        bottom: '20px',
        right: '16px',
        pointerEvents: 'all !important',
    },
    '.paypal_container': {
        width: '100%',
    },
    '.sr-only': {
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: '0',
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: '0',
    },
}

export default globalStyles
